export default __webpack_public_path__ + "static/media/28-price-giving-ceremony.14c208d8.jpeg";